import React from 'react';
import Icon from './Icon';

export function Spinner({ large = false, label }) {
  return (
    <span
      className={large ? 'spinner spinner-lg' : 'spinner'}
      role="status"
      aria-label={label || 'Loading'}
    />
  );
}

export function LoadingBlock({ text = 'Loading…' }) {
  return (
    <div className="loading-block">
      <Spinner large />
      <span>{text}</span>
    </div>
  );
}

export function Alert({ kind = 'error', children }) {
  const icon = kind === 'success' ? 'checkCircle' : kind === 'info' ? 'info' : 'alert';
  return (
    <div className={`alert alert-${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      <Icon name={icon} size={17} />
      <span>{children}</span>
    </div>
  );
}

export function EmptyState({ icon = 'sparkle', title, text, action }) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <Icon name={icon} size={26} />
      </div>
      <div className="empty-state-title">{title}</div>
      {text && <p className="empty-state-text">{text}</p>}
      {action}
    </div>
  );
}

export function BotBadge({ children = 'AI' }) {
  return <span className="badge badge-ai">{children}</span>;
}

export function TopBar({ title, subtitle, left, right, children }) {
  return (
    <header className="topbar">
      <div className="topbar-inner">
        {left}
        {children || (
          <div className="topbar-title">
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</div>
            {subtitle && <div className="topbar-subtitle">{subtitle}</div>}
          </div>
        )}
        {right}
      </div>
    </header>
  );
}

export function BackButton({ onClick, className = '' }) {
  return (
    <button type="button" className={`icon-btn ${className}`.trim()} onClick={onClick} aria-label="Go back">
      <Icon name="back" size={19} />
    </button>
  );
}

export function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div className="toast-host">
      <div className={`toast toast-${toast.kind}`} role="status" aria-live="polite">
        <Icon name={toast.kind === 'success' ? 'checkCircle' : 'alert'} size={18} />
        <span>{toast.message}</span>
      </div>
    </div>
  );
}
